{
  "openapi": "3.0.3",
  "info": {
    "title": "Songstar",
    "version": "1.0.0"
  },
  "servers": [
    {
      "url": "/api"
    }
  ],
  "tags": [
    {
      "name": "game"
    },
    {
      "name": "health"
    },
    {
      "name": "playlists"
    },
    {
      "name": "streams"
    }
  ],
  "paths": {
    "/feedback": {
      "get": {
        "operationId": "allFeedback",
        "x-error-slugs": [
          "internal-server-error",
          "not-an-admin"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "200": {
            "description": "Every player's feedback",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/FeedbackList"
                }
              }
            }
          },
          "401": {
            "description": "The request does not come through the login of a user in the group admins",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The feedback could not be fetched",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game": {
      "get": {
        "operationId": "viewGame",
        "x-error-slugs": [
          "internal-server-error",
          "no-player-session",
          "not-a-player",
          "phase-mismatch"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "200": {
            "description": "The game, as the player sees it in its phase",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/GameView"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game view could not be fetched",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/games": {
      "post": {
        "operationId": "hostGame",
        "x-error-slugs": [
          "host-already-hosted-game",
          "internal-server-error",
          "invalid-body",
          "invalid-nickname",
          "invalid-playlist",
          "no-host-sign-in",
          "playlist-mode-off"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/HostGameRequest"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The game is hosted, and the session belongs to its host player"
          },
          "400": {
            "description": "The nickname is invalid, this sign-in already hosted a game, playlist mode is off, or the playlist does not fit the mode",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The session has no completed Spotify sign-in",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game could not be hosted",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/feedback": {
      "put": {
        "operationId": "leaveFeedback",
        "x-error-slugs": [
          "game-abandoned",
          "internal-server-error",
          "invalid-body",
          "no-player-session",
          "not-a-player",
          "phase-mismatch"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/LeaveFeedbackRequest"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The feedback is saved"
          },
          "400": {
            "description": "The body is not feedback, the game is not over, or the player is not found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The feedback could not be saved",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/phase-lengths": {
      "put": {
        "operationId": "changePhaseLengths",
        "x-error-slugs": [
          "game-abandoned",
          "game-over",
          "internal-server-error",
          "invalid-body",
          "invalid-phase-lengths",
          "no-player-session",
          "not-a-player",
          "not-the-host"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ChangePhaseLengthsRequest"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The phases given changed length"
          },
          "400": {
            "description": "The body is not a set of phase lengths of one second or longer, or the game is over",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not the host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The phase lengths could not be changed",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/rounds": {
      "put": {
        "operationId": "changeRounds",
        "x-error-slugs": [
          "game-abandoned",
          "game-over",
          "internal-server-error",
          "invalid-body",
          "invalid-rounds",
          "no-player-session",
          "not-a-player",
          "not-the-host",
          "rounds-above-songs",
          "rounds-below-current-round"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/ChangeRoundsRequest"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The number of rounds changed"
          },
          "400": {
            "description": "The body is not a number of rounds",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not the host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The number of rounds could not be changed",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/pause": {
      "post": {
        "operationId": "pauseGame",
        "x-error-slugs": [
          "countdown-changed",
          "countdown-ran-out",
          "game-abandoned",
          "game-already-paused",
          "internal-server-error",
          "no-player-session",
          "not-a-player",
          "not-the-host",
          "phase-cannot-be-paused"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "204": {
            "description": "The game is paused"
          },
          "400": {
            "description": "The phase cannot be paused",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not the host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game could not be paused",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/start": {
      "post": {
        "operationId": "startGame",
        "x-error-slugs": [
          "game-abandoned",
          "internal-server-error",
          "no-player-session",
          "no-songs-to-draw",
          "not-a-player",
          "not-enough-active-players",
          "not-the-host",
          "phase-mismatch"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "204": {
            "description": "The game is starting"
          },
          "400": {
            "description": "Too few active players to start",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not the host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game could not be started",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/unpause": {
      "post": {
        "operationId": "unpauseGame",
        "x-error-slugs": [
          "game-abandoned",
          "game-not-paused",
          "game-over",
          "internal-server-error",
          "no-player-session",
          "not-a-player",
          "not-the-host"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "204": {
            "description": "The game is resumed"
          },
          "400": {
            "description": "The game is not paused",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not the host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game could not be resumed",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/games/{code}": {
      "get": {
        "operationId": "gameInProgressByCode",
        "x-error-slugs": [
          "game-not-found",
          "internal-server-error",
          "invalid-game-code"
        ],
        "tags": [
          "game"
        ],
        "parameters": [
          {
            "name": "code",
            "in": "path",
            "required": true,
            "schema": {
              "$ref": "#/components/schemas/GameCode"
            }
          }
        ],
        "responses": {
          "204": {
            "description": "A game with this code exists"
          },
          "400": {
            "description": "The game code is not a number in the int16 range, or no game has this code",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The game could not be looked up",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/health": {
      "get": {
        "operationId": "health",
        "tags": [
          "health"
        ],
        "description": "Whether the database and Spotify answer the backend, for a probe from outside the home. Spotify's answer is reused for 30 s, so probes close together ask Spotify once.",
        "responses": {
          "200": {
            "description": "The database and Spotify both answer",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Health"
                }
              }
            }
          },
          "503": {
            "description": "The database or Spotify does not answer",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/Health"
                }
              }
            }
          }
        }
      }
    },
    "/game/heartbeat": {
      "post": {
        "operationId": "recordHeartbeat",
        "x-error-slugs": [
          "game-abandoned",
          "game-over",
          "internal-server-error",
          "no-player-session",
          "not-a-player"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "204": {
            "description": "The player is still active"
          },
          "400": {
            "description": "The game is over, or the player is not found",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The heartbeat could not be recorded",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/games/{code}/players": {
      "post": {
        "operationId": "joinGame",
        "x-error-slugs": [
          "game-abandoned",
          "game-not-found",
          "game-over",
          "internal-server-error",
          "invalid-body",
          "invalid-game-code",
          "invalid-nickname",
          "nickname-taken"
        ],
        "tags": [
          "game"
        ],
        "parameters": [
          {
            "name": "code",
            "in": "path",
            "required": true,
            "schema": {
              "$ref": "#/components/schemas/GameCode"
            }
          }
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/JoinGameRequest"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The player joined, and the session belongs to them"
          },
          "400": {
            "description": "The game code is not a number in the int16 range, no game has this code, or the nickname is invalid or taken",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The player could not join",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/notifications": {
      "get": {
        "operationId": "gameNotifications",
        "x-error-slugs": [
          "internal-server-error",
          "no-player-session",
          "not-a-player"
        ],
        "tags": [
          "streams"
        ],
        "description": "A stream of server-sent events that never ends. It opens with the comment \":ok\", then a TRACE event when the request carries a valid span. GAME_CHANGED and TIME events follow, as `event: <NotificationTopic>` and `data: <data>` frames whose data the schemas GameChangedNotification, TimeNotification and TraceNotification type. The comment \":keep-alive\" arrives every 30 s.",
        "responses": {
          "200": {
            "description": "The stream is open",
            "content": {
              "text/event-stream": {}
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The stream could not be opened",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/livez": {
      "get": {
        "operationId": "livez",
        "tags": [
          "health"
        ],
        "responses": {
          "200": {
            "description": "The server's process answers",
            "content": {
              "text/plain": {
                "schema": {
                  "type": "string",
                  "enum": [
                    "ok"
                  ]
                }
              }
            }
          }
        }
      }
    },
    "/readyz": {
      "get": {
        "operationId": "readyz",
        "tags": [
          "health"
        ],
        "responses": {
          "200": {
            "description": "The server can reach its database",
            "content": {
              "text/plain": {
                "schema": {
                  "type": "string",
                  "enum": [
                    "ok"
                  ]
                }
              }
            }
          },
          "503": {
            "description": "The server cannot reach its database",
            "content": {
              "text/plain": {
                "schema": {
                  "type": "string",
                  "enum": [
                    "not ready"
                  ]
                }
              }
            }
          }
        }
      }
    },
    "/session": {
      "get": {
        "operationId": "playerSession",
        "x-error-slugs": [
          "internal-server-error"
        ],
        "tags": [
          "game"
        ],
        "responses": {
          "200": {
            "description": "The session's player and the code of their game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/PlayerSession"
                }
              }
            }
          },
          "204": {
            "description": "The session has no player, or its game was abandoned, or its host started a new sign-in"
          },
          "500": {
            "description": "The session could not be read",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/suggestions": {
      "get": {
        "operationId": "searchSongs",
        "x-error-slugs": [
          "game-over",
          "internal-server-error",
          "invalid-game-code",
          "missing-search",
          "no-player-session",
          "not-a-player",
          "phase-mismatch"
        ],
        "tags": [
          "game"
        ],
        "parameters": [
          {
            "name": "search",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string"
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The songs relevant to the search",
            "content": {
              "application/json": {
                "schema": {
                  "type": "array",
                  "items": {
                    "$ref": "#/components/schemas/Song"
                  }
                }
              }
            }
          },
          "400": {
            "description": "The search is missing or blank, or the game is neither in player choosing nor in players guessing",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The songs could not be searched",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/choose-song": {
      "post": {
        "operationId": "chooseSong",
        "x-error-slugs": [
          "countdown-changed",
          "countdown-ran-out",
          "game-abandoned",
          "game-paused",
          "inactive-device",
          "internal-server-error",
          "invalid-body",
          "no-player-session",
          "not-the-chooser",
          "phase-mismatch",
          "song-not-found"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SongChoice"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The song is chosen, and plays on the host's Spotify"
          },
          "400": {
            "description": "The body is not a song's ID, the catalog lacks the song, the game is not in player choosing, the chooser already chose a song this round, or the host's device is inactive",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game or not the chooser",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The song could not be chosen",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/game/guess-song": {
      "post": {
        "operationId": "guessSong",
        "x-error-slugs": [
          "already-guessed",
          "chooser-cannot-guess",
          "countdown-changed",
          "countdown-ran-out",
          "game-abandoned",
          "game-paused",
          "internal-server-error",
          "invalid-body",
          "no-player-session",
          "not-a-player",
          "phase-mismatch",
          "song-not-found"
        ],
        "tags": [
          "game"
        ],
        "requestBody": {
          "required": true,
          "content": {
            "application/json": {
              "schema": {
                "$ref": "#/components/schemas/SongChoice"
              }
            }
          }
        },
        "responses": {
          "204": {
            "description": "The guess is made"
          },
          "400": {
            "description": "The body is not a song's ID, the catalog lacks the song, the game is not in players guessing, or the guesser already guessed this round",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The request carries no player session, or the player is not in the game or is the chooser",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "500": {
            "description": "The guess could not be made",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/spotify/playlists": {
      "get": {
        "operationId": "hostPlaylists",
        "x-error-slugs": [
          "internal-server-error",
          "no-host-sign-in"
        ],
        "tags": [
          "playlists"
        ],
        "responses": {
          "200": {
            "description": "The host's playlists, each with whether Spotify returns its songs",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SpotifyPlaylists"
                }
              }
            }
          },
          "401": {
            "description": "The session has no signed-in host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "404": {
            "description": "The playlist-mode flag is off"
          },
          "500": {
            "description": "Spotify could not be asked",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    },
    "/spotify/playlists/search": {
      "get": {
        "operationId": "searchPlaylists",
        "x-error-slugs": [
          "internal-server-error",
          "no-host-sign-in",
          "no-search"
        ],
        "tags": [
          "playlists"
        ],
        "parameters": [
          {
            "name": "q",
            "in": "query",
            "required": true,
            "schema": {
              "type": "string",
              "minLength": 1
            }
          }
        ],
        "responses": {
          "200": {
            "description": "The playlists matching the search, each with whether Spotify returns its songs",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/SpotifyPlaylists"
                }
              }
            }
          },
          "400": {
            "description": "The search is empty",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "401": {
            "description": "The session has no signed-in host",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          },
          "404": {
            "description": "The playlist-mode flag is off"
          },
          "500": {
            "description": "Spotify could not be asked",
            "content": {
              "application/json": {
                "schema": {
                  "$ref": "#/components/schemas/ErrorResponse"
                }
              }
            }
          }
        }
      }
    }
  },
  "components": {
    "schemas": {
      "ChangePhaseLengthsRequest": {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "chooserTime": {
            "$ref": "#/components/schemas/PhaseLength"
          },
          "gameStartingTime": {
            "$ref": "#/components/schemas/PhaseLength"
          },
          "guessersTime": {
            "$ref": "#/components/schemas/PhaseLength"
          }
        }
      },
      "ChangeRoundsRequest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "rounds"
        ],
        "properties": {
          "rounds": {
            "type": "integer",
            "format": "int16",
            "minimum": -32768,
            "maximum": 32767
          }
        }
      },
      "ErrorResponse": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "message",
          "slug"
        ],
        "properties": {
          "message": {
            "type": "string"
          },
          "slug": {
            "type": "string",
            "enum": [
              "already-guessed",
              "chooser-cannot-guess",
              "countdown-changed",
              "countdown-ran-out",
              "game-abandoned",
              "game-already-paused",
              "game-not-found",
              "game-not-paused",
              "game-over",
              "game-paused",
              "guessing-already-began",
              "heartbeat-dropped",
              "host-already-hosted-game",
              "inactive-device",
              "internal-server-error",
              "invalid-body",
              "invalid-game-code",
              "invalid-nickname",
              "invalid-phase-lengths",
              "invalid-playlist",
              "invalid-rounds",
              "invalid-spotify-callback",
              "missing-search",
              "nickname-taken",
              "no-host-sign-in",
              "no-player-session",
              "no-search",
              "not-a-player",
              "no-song-drawn",
              "no-songs-to-draw",
              "not-an-admin",
              "not-enough-active-players",
              "not-the-chooser",
              "not-the-host",
              "phase-cannot-be-paused",
              "phase-mismatch",
              "playlist-mode-off",
              "rounds-above-songs",
              "rounds-below-current-round",
              "song-already-playing",
              "song-not-found"
            ],
            "x-messages": {
              "already-guessed": "you have already guessed",
              "chooser-cannot-guess": "the chooser cannot guess",
              "countdown-changed": "the countdown changed",
              "countdown-ran-out": "the countdown ran out",
              "game-abandoned": "the game is abandoned",
              "game-already-paused": "the game is already paused",
              "game-not-found": "no game in progress has that code",
              "game-not-paused": "the game is not paused",
              "game-over": "the game is over",
              "game-paused": "the game is paused",
              "guessing-already-began": "guessing has already begun",
              "heartbeat-dropped": "the heartbeat could not get the game's row lock in time",
              "host-already-hosted-game": "this sign-in already hosted a game",
              "inactive-device": "No active Spotify device. Start playing music on Spotify on the host device and try again.",
              "internal-server-error": "unexpected server error",
              "invalid-body": "the request is not one the server reads",
              "invalid-game-code": "a game code is a number",
              "invalid-nickname": "a player's nickname must be between 1 and 15 characters",
              "invalid-phase-lengths": "a phase length is out of range",
              "invalid-playlist": "a playlist game needs the playlist to play, and a standard game takes none",
              "invalid-rounds": "the number of rounds is out of range",
              "invalid-spotify-callback": "the Spotify sign-in did not complete",
              "missing-search": "the search is missing",
              "nickname-taken": "the nickname is already taken",
              "no-host-sign-in": "no host sign-in",
              "no-player-session": "no player session",
              "no-search": "the search is missing",
              "not-a-player": "you are not allowed to perform this action",
              "no-song-drawn": "no song is drawn for the round",
              "no-songs-to-draw": "the host has no songs to draw",
              "not-an-admin": "you are not allowed to perform this action",
              "not-enough-active-players": "at least 2 active players are required to start the game",
              "not-the-chooser": "you are not allowed to perform this action",
              "not-the-host": "you are not allowed to perform this action",
              "phase-cannot-be-paused": "the phase cannot be paused",
              "phase-mismatch": "the game is in another phase",
              "playlist-mode-off": "playlist mode is not available",
              "rounds-above-songs": "the number of rounds is above the songs to play",
              "rounds-below-current-round": "the number of rounds is below the current round",
              "song-already-playing": "the song is already playing",
              "song-not-found": "song not found"
            }
          }
        }
      },
      "Feedback": {
        "type": "object",
        "required": [
          "createdAt",
          "feedback",
          "id",
          "nickname"
        ],
        "properties": {
          "createdAt": {
            "type": "string",
            "format": "date-time"
          },
          "feedback": {
            "type": "string"
          },
          "id": {
            "type": "integer",
            "format": "int64"
          },
          "nickname": {
            "type": "string"
          }
        }
      },
      "FeedbackList": {
        "type": "object",
        "required": [
          "feedback"
        ],
        "properties": {
          "feedback": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Feedback"
            }
          }
        }
      },
      "GameChangedNotification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "data",
          "event"
        ],
        "properties": {
          "data": {
            "type": "string",
            "maxLength": 0
          },
          "event": {
            "$ref": "#/components/schemas/NotificationTopic"
          }
        }
      },
      "GameCode": {
        "type": "integer",
        "format": "int16",
        "minimum": -32768,
        "maximum": 32767
      },
      "GameConfig": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "chooserTime",
          "gameStartingTime",
          "guessersTime",
          "mode",
          "roundResultsTime",
          "rounds"
        ],
        "properties": {
          "chooserTime": {
            "type": "integer"
          },
          "gameStartingTime": {
            "type": "integer"
          },
          "guessersTime": {
            "type": "integer"
          },
          "mode": {
            "$ref": "#/components/schemas/GameMode"
          },
          "roundResultsTime": {
            "type": "integer"
          },
          "rounds": {
            "type": "integer"
          }
        }
      },
      "GameMode": {
        "type": "string",
        "enum": [
          "STANDARD",
          "PLAYLIST"
        ],
        "description": "How the game picks each round's song; hosting a PLAYLIST game is refused while its flag is off"
      },
      "GameOverView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "feedback",
          "gameCode",
          "gameConfig",
          "gameId",
          "hostPlayer",
          "paused",
          "phase",
          "player",
          "playerId",
          "round",
          "standing"
        ],
        "properties": {
          "feedback": {
            "type": "string",
            "nullable": true
          },
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "gameConfig": {
            "$ref": "#/components/schemas/GameConfig"
          },
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "hostPlayer": {
            "$ref": "#/components/schemas/Player"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          },
          "round": {
            "$ref": "#/components/schemas/RoundResultsRound"
          },
          "standing": {
            "$ref": "#/components/schemas/Standing"
          }
        }
      },
      "GameStartingView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameId",
          "paused",
          "phase",
          "playerId"
        ],
        "properties": {
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          }
        }
      },
      "GameView": {
        "oneOf": [
          {
            "$ref": "#/components/schemas/GameOverView"
          },
          {
            "$ref": "#/components/schemas/GameStartingView"
          },
          {
            "$ref": "#/components/schemas/LobbyView"
          },
          {
            "$ref": "#/components/schemas/PlayerChoosingView"
          },
          {
            "$ref": "#/components/schemas/PlayersGuessingView"
          },
          {
            "$ref": "#/components/schemas/RoundResultsView"
          }
        ],
        "discriminator": {
          "propertyName": "phase",
          "mapping": {
            "GAME_OVER": "#/components/schemas/GameOverView",
            "GAME_STARTING": "#/components/schemas/GameStartingView",
            "LOBBY": "#/components/schemas/LobbyView",
            "PLAYERS_GUESSING": "#/components/schemas/PlayersGuessingView",
            "PLAYER_CHOOSING": "#/components/schemas/PlayerChoosingView",
            "ROUND_RESULTS": "#/components/schemas/RoundResultsView"
          }
        }
      },
      "Health": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "database",
          "spotify"
        ],
        "properties": {
          "database": {
            "$ref": "#/components/schemas/HealthState"
          },
          "spotify": {
            "$ref": "#/components/schemas/HealthState"
          }
        }
      },
      "HealthState": {
        "type": "string",
        "enum": [
          "UP",
          "DOWN"
        ]
      },
      "HostGameRequest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "nickname"
        ],
        "properties": {
          "nickname": {
            "$ref": "#/components/schemas/Nickname"
          },
          "mode": {
            "$ref": "#/components/schemas/GameMode"
          },
          "playlistId": {
            "type": "string",
            "description": "The playlist a PLAYLIST game draws its songs from: the id of one of the host's Spotify playlists; a STANDARD game takes none"
          }
        }
      },
      "JoinGameRequest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "nickname"
        ],
        "properties": {
          "nickname": {
            "$ref": "#/components/schemas/Nickname"
          }
        }
      },
      "LeaveFeedbackRequest": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "feedback"
        ],
        "properties": {
          "feedback": {
            "type": "string",
            "maxLength": 2000
          }
        }
      },
      "LobbyView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameCode",
          "gameConfig",
          "gameId",
          "hostPlayer",
          "mayStart",
          "paused",
          "phase",
          "phaseLengthsRange",
          "player",
          "playerId",
          "players",
          "roundsRange",
          "standing"
        ],
        "properties": {
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "gameConfig": {
            "$ref": "#/components/schemas/GameConfig"
          },
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "hostPlayer": {
            "$ref": "#/components/schemas/Player"
          },
          "mayStart": {
            "type": "boolean"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "phaseLengthsRange": {
            "$ref": "#/components/schemas/PhaseLengthsRange"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          },
          "players": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/Player"
            }
          },
          "roundsRange": {
            "$ref": "#/components/schemas/Range"
          },
          "standing": {
            "$ref": "#/components/schemas/Standing"
          }
        }
      },
      "Nickname": {
        "type": "string",
        "minLength": 1,
        "maxLength": 15,
        "pattern": "\\S"
      },
      "NotificationTopic": {
        "type": "string",
        "enum": [
          "GAME_CHANGED",
          "TIME",
          "TRACE"
        ]
      },
      "PauseReason": {
        "type": "string",
        "enum": [
          "failed-choice",
          "host",
          "lost-host-device"
        ]
      },
      "PhaseLength": {
        "type": "integer",
        "format": "int16",
        "minimum": -32768,
        "maximum": 32767
      },
      "PhaseLengthsRange": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "chooserTime",
          "guessersTime"
        ],
        "properties": {
          "chooserTime": {
            "$ref": "#/components/schemas/Range"
          },
          "guessersTime": {
            "$ref": "#/components/schemas/Range"
          }
        }
      },
      "Player": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "active",
          "id",
          "nickname"
        ],
        "properties": {
          "active": {
            "type": "boolean"
          },
          "id": {
            "type": "integer",
            "format": "int64"
          },
          "nickname": {
            "type": "string"
          }
        }
      },
      "PlayerChoosingView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameCode",
          "gameConfig",
          "gameId",
          "hostPlayer",
          "paused",
          "phase",
          "phaseLengthsRange",
          "player",
          "playerId",
          "round",
          "roundsRange",
          "roundsUntilIChoose",
          "standing",
          "targetRange"
        ],
        "properties": {
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "gameConfig": {
            "$ref": "#/components/schemas/GameConfig"
          },
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "hostPlayer": {
            "$ref": "#/components/schemas/Player"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "phaseLengthsRange": {
            "$ref": "#/components/schemas/PhaseLengthsRange"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          },
          "round": {
            "$ref": "#/components/schemas/Round"
          },
          "roundsRange": {
            "$ref": "#/components/schemas/Range"
          },
          "roundsUntilIChoose": {
            "type": "integer",
            "nullable": true
          },
          "standing": {
            "$ref": "#/components/schemas/Standing"
          },
          "targetRange": {
            "$ref": "#/components/schemas/Range"
          }
        }
      },
      "PlayerSession": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameCode",
          "isHost",
          "nickname"
        ],
        "properties": {
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "isHost": {
            "type": "boolean"
          },
          "nickname": {
            "type": "string"
          }
        }
      },
      "PlayersGuessingRound": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "number",
          "songSubmission"
        ],
        "properties": {
          "chooser": {
            "$ref": "#/components/schemas/Player"
          },
          "number": {
            "type": "integer"
          },
          "songSubmission": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/SongSubmission"
              }
            ]
          }
        }
      },
      "PlayersGuessingView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameCode",
          "gameConfig",
          "gameId",
          "hostPlayer",
          "paused",
          "phase",
          "phaseLengthsRange",
          "player",
          "playerId",
          "round",
          "roundsRange",
          "roundsUntilIChoose",
          "standing"
        ],
        "properties": {
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "gameConfig": {
            "$ref": "#/components/schemas/GameConfig"
          },
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "hostPlayer": {
            "$ref": "#/components/schemas/Player"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "phaseLengthsRange": {
            "$ref": "#/components/schemas/PhaseLengthsRange"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          },
          "round": {
            "$ref": "#/components/schemas/PlayersGuessingRound"
          },
          "roundsRange": {
            "$ref": "#/components/schemas/Range"
          },
          "roundsUntilIChoose": {
            "type": "integer",
            "nullable": true
          },
          "standing": {
            "$ref": "#/components/schemas/Standing"
          }
        }
      },
      "Range": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "fewest",
          "most"
        ],
        "properties": {
          "fewest": {
            "type": "integer"
          },
          "most": {
            "type": "integer"
          }
        }
      },
      "Round": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "number"
        ],
        "properties": {
          "chooser": {
            "$ref": "#/components/schemas/Player"
          },
          "number": {
            "type": "integer"
          }
        }
      },
      "RoundResultsRound": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "chooserSongSubmissionScore",
          "number",
          "songSubmissionScore",
          "songSubmissionScores"
        ],
        "properties": {
          "chooser": {
            "$ref": "#/components/schemas/Player"
          },
          "chooserSongSubmissionScore": {
            "$ref": "#/components/schemas/SongSubmissionScore"
          },
          "number": {
            "type": "integer"
          },
          "songSubmissionScore": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/SongSubmissionScore"
              }
            ]
          },
          "songSubmissionScores": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SongSubmissionScore"
            }
          }
        }
      },
      "RoundResultsView": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "gameCode",
          "gameConfig",
          "gameId",
          "hostPlayer",
          "paused",
          "phase",
          "phaseLengthsRange",
          "player",
          "playerId",
          "round",
          "roundsRange",
          "standing"
        ],
        "properties": {
          "gameCode": {
            "$ref": "#/components/schemas/GameCode"
          },
          "gameConfig": {
            "$ref": "#/components/schemas/GameConfig"
          },
          "gameId": {
            "type": "integer",
            "format": "int64"
          },
          "hostPlayer": {
            "$ref": "#/components/schemas/Player"
          },
          "paused": {
            "type": "boolean"
          },
          "pauseReason": {
            "$ref": "#/components/schemas/PauseReason"
          },
          "phase": {
            "type": "string"
          },
          "phaseLengthsRange": {
            "$ref": "#/components/schemas/PhaseLengthsRange"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "playerId": {
            "type": "integer",
            "format": "int64"
          },
          "round": {
            "$ref": "#/components/schemas/RoundResultsRound"
          },
          "roundsRange": {
            "$ref": "#/components/schemas/Range"
          },
          "standing": {
            "$ref": "#/components/schemas/Standing"
          }
        }
      },
      "Song": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "albumImages",
          "artists",
          "id",
          "playbackURI",
          "title",
          "year"
        ],
        "properties": {
          "albumImages": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "artists": {
            "type": "array",
            "items": {
              "type": "string"
            }
          },
          "id": {
            "type": "string"
          },
          "playbackURI": {
            "type": "string"
          },
          "title": {
            "type": "string"
          },
          "year": {
            "type": "integer",
            "format": "int16",
            "minimum": -32768,
            "maximum": 32767
          }
        }
      },
      "SongChoice": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id"
        ],
        "properties": {
          "id": {
            "type": "string"
          }
        }
      },
      "SongSubmission": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "song",
          "submittedAt"
        ],
        "properties": {
          "song": {
            "$ref": "#/components/schemas/Song"
          },
          "submittedAt": {
            "type": "string",
            "format": "date-time"
          }
        }
      },
      "SongSubmissionScore": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "playerStanding",
          "score",
          "scoreType",
          "songSubmission"
        ],
        "properties": {
          "playerStanding": {
            "$ref": "#/components/schemas/Standing"
          },
          "score": {
            "type": "integer"
          },
          "scoreType": {
            "type": "string",
            "enum": [
              "chooser",
              "correct",
              "no-song-submission",
              "partially-correct",
              "wrong"
            ]
          },
          "songSubmission": {
            "nullable": true,
            "allOf": [
              {
                "$ref": "#/components/schemas/SongSubmission"
              }
            ]
          }
        }
      },
      "SpotifyPlaylist": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "id",
          "name",
          "owner",
          "songsReadable"
        ],
        "properties": {
          "id": {
            "type": "string"
          },
          "name": {
            "type": "string"
          },
          "owner": {
            "type": "string"
          },
          "songsReadable": {
            "type": "boolean"
          }
        }
      },
      "SpotifyPlaylists": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "playlists"
        ],
        "properties": {
          "playlists": {
            "type": "array",
            "items": {
              "$ref": "#/components/schemas/SpotifyPlaylist"
            }
          }
        }
      },
      "Standing": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "placement",
          "player",
          "score"
        ],
        "properties": {
          "placement": {
            "type": "integer"
          },
          "player": {
            "$ref": "#/components/schemas/Player"
          },
          "score": {
            "type": "integer"
          }
        }
      },
      "TimeNotification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "data",
          "event"
        ],
        "properties": {
          "data": {
            "type": "integer",
            "description": "The seconds left of the current phase"
          },
          "event": {
            "$ref": "#/components/schemas/NotificationTopic"
          }
        }
      },
      "TraceNotification": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "data",
          "event"
        ],
        "properties": {
          "data": {
            "type": "string",
            "description": "The W3C traceparent of the request that opened the stream",
            "pattern": "^00-[0-9a-f]{32}-[0-9a-f]{16}-[0-9a-f]{2}$"
          },
          "event": {
            "$ref": "#/components/schemas/NotificationTopic"
          }
        }
      }
    }
  }
}
